import React, { useState } from "react";
import BuilderRightSideBar from "../../../Layouts/BuilderRightSideBar";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import JobConfigration from "../../../components/BuilderComponents/JobConfigration/JobConfigration";
import { ReactSortable } from "react-sortablejs";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import CustomJS from "../../../components/BuilderComponents/CustomJS";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import Label from "../../../components/FormComponents/Label";

const templateObject = {};

const ActivityJobTrigger = ({
  jobTriggerFormula = "",
  setJobTriggerFormula,
  jobTriggerData,
  setJobTriggerData,
  stateid,
  actId,
  pageType,
  jobType,
  allJobs,
  isSmJob = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCustomJsModalOpen, setIsCustomJsModalOpen] = useState(false);

  const addTriggerdJob = (data) => {
    setJobTriggerData([...jobTriggerData, data]);
    setIsOpen(false);
  };

  const getJobDescription = (jobType, pageType) => {
    const typeName = pageType === "entity" ? "Registration" : "Activity";

    switch (jobType) {
      case "post":
        return `Post ${typeName} Jobs`;
      case "pre":
        return `Pre ${typeName} Jobs`;
      case "pre_submission":
        return `Pre Submission ${typeName} Jobs`;
      case "triggers":
        return "Triggers";
      case "sm_trigger_job":
        return "Triggers";
      default:
        return "Jobs";
    }
  };

  return (
    <div>
      <div
        className={jobTriggerData.length === 0 ? "activity_select_top_block empty-state" : "activity_select_top_block"}
      >
        <div className="post_activity_top">
          <div className="section_sub_heading">{getJobDescription(jobType, pageType)}</div>
          <MaterialIcon name="add" className="builder_action_btn_new" onClick={() => setIsOpen(true)} />
        </div>

        <div className="flex_column gap_2">
          {jobType === "post" && (
            <div className="d_flex justify_between">
              <Label className="builder_label">Execution center</Label>
              {jobTriggerFormula?.trim() === "" ? (
                <button onClick={() => setIsCustomJsModalOpen(true)} className="builder_btn_secondary">
                  Add
                </button>
              ) : (
                <ButtonActionIcon type="fullscreen" title="Fullscreen" onClick={() => setIsCustomJsModalOpen(true)} />
              )}
            </div>
          )}

          {jobType === "post" && jobTriggerData.length > 0 && jobTriggerFormula && (
            <CustomJS
              showFullScreenIcon={false}
              inputString={jobTriggerFormula}
              tableID={stateid}
              handleChange={(data) => setJobTriggerFormula(data)}
              label=""
              height="200px"
            />
          )}
          <RenderJobsList
            jobTriggerData={jobTriggerData}
            setJobTriggerData={setJobTriggerData}
            stateid={stateid}
            actId={actId}
            templateObject={templateObject}
            allJobs={allJobs}
            isSmJob={isSmJob}
          />
        </div>
      </div>

      <BuilderRightSideBar
        style={{ width: "600px" }} //TODO:standardize it later
        isOpen={isOpen}
        heading="Add Job"
        onClose={(res) => setIsOpen(res)}
        size="medium"
      >
        <div className="edit_activity_job">
          <JobConfigration
            smId={stateid}
            actId={actId}
            onClick={addTriggerdJob}
            templateObject={templateObject}
            allJobs={allJobs}
            isSmJob={isSmJob}
          />
        </div>
      </BuilderRightSideBar>

      <BuilderModal
        isOpen={isCustomJsModalOpen}
        onClose={() => setIsCustomJsModalOpen(false)}
        modalName="Custom JS Function"
        bodyStyle={{ width: "86vw", height: "74vh" }}
        customStyleClsName="customjs_full_screen"
      >
        <CustomJS
          showFullScreenIcon={false}
          inputString={jobTriggerFormula}
          tableID={stateid}
          handleChange={(data) => setJobTriggerFormula(data)}
          label="Function"
          height="70vh"
        />
      </BuilderModal>
    </div>
  );
};
export default ActivityJobTrigger;

const RenderJobsList = ({ jobTriggerData, stateid, actId, setJobTriggerData, templateObject, allJobs, isSmJob }) => {
  const [isEditOpen, setIsEditOpen] = useState("");

  const editJobTriggerData = (data) => {
    const newJobTriggerData = jobTriggerData.map((job, index) => {
      if (index === isEditOpen) {
        return data;
      }
      return job;
    });

    setJobTriggerData(newJobTriggerData);
    setIsEditOpen(false);
  };
  const deleteJobtrigger = (index) => {
    const newTriggerData = jobTriggerData.filter((_, i) => i !== index);
    setJobTriggerData(newTriggerData);
  };
  const handleChangeListOrder = (newList) => {
    setJobTriggerData(newList);
  };

  return (
    <div>
      {!isEditOpen && isEditOpen !== 0 && (
        <div className="job_single_card_container">
          <ReactSortable
            filter=".addImageButtonContainer"
            handle=".Recordsviewfielddragclass"
            list={jobTriggerData}
            setList={handleChangeListOrder}
            animation="200"
            easing="ease-out"
            className="flex_column gap_3 mb_1"
          >
            {jobTriggerData.map((singleJob, index) => {
              return (
                <div className="flex_column w_100" key={singleJob.id}>
                  <div className="d_flex gap_1" style={{ position: "relative" }}>
                    <span className="job_reorder_icon Recordsviewfielddragclass drag_icon" style={{ cursor: "move" }}>
                      {index}
                    </span>

                    <div className="job_single_card w_100 overflow_hidden">
                      <div className="overlay_cover"></div>
                      <div className="job_action_btn ">
                        <ButtonActionIcon size="sm" type="edit" onClick={() => setIsEditOpen(index)} />
                        <ButtonActionIcon size="sm" type="delete" onClick={() => deleteJobtrigger(index)} />
                      </div>
                      <JobConfigration
                        editJob={singleJob}
                        smId={stateid}
                        actId={actId}
                        onClick={editJobTriggerData}
                        templateObject={templateObject}
                        isReadOnly={true}
                        allJobs={allJobs}
                        isSmJob={isSmJob}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </ReactSortable>
        </div>
      )}
      <BuilderRightSideBar
        style={{ width: "600px" }} //TODO:standardize it later
        isOpen={isEditOpen || isEditOpen === 0}
        heading="Edit Job"
        onClose={(res) => setIsEditOpen(res)}
        size="medium"
      >
        <div className="edit_activity_job">
          <JobConfigration
            editJob={jobTriggerData[isEditOpen]}
            smId={stateid}
            actId={actId}
            onClick={editJobTriggerData}
            templateObject={templateObject}
            allJobs={allJobs}
            isSmJob={isSmJob}
          />
        </div>
      </BuilderRightSideBar>
    </div>
  );
};
